import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { INetSuiteAccounts } from '../models';

const baseUrl = '/api/Admin/NetsuiteAccounts';

export const INetsuiteAccountsAPI = {
  async getAll(): Promise<INetSuiteAccounts[]> {
    try {
      const response: AxiosResponse<INetSuiteAccounts[]> = await authFetch.get(baseUrl);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async upsert(upsertData: INetSuiteAccounts[]): Promise<INetSuiteAccounts[]> {
    try {
      const response: AxiosResponse<INetSuiteAccounts[]> = await authFetch.put(baseUrl, {mappings: upsertData});

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
